export const storeLst = {
    "98#": require("@/utils/module/gas-98.json")
}
